// extracted by mini-css-extract-plugin
var _1 = "message-AAGpu";
export { _1 as "message" }
